var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _FormFloat_instances, _FormFloat_shouldEnableFloat;
import $ from 'jquery';
export class FormFloat {
    constructor() {
        _FormFloat_instances.add(this);
        this.selector = '.form-float';
        if ($(this.selector).length === 0)
            return;
        $(this.selector).each((_, element) => {
            __classPrivateFieldGet(this, _FormFloat_instances, "m", _FormFloat_shouldEnableFloat).call(this, element);
            $(element).on('blur', () => {
                __classPrivateFieldGet(this, _FormFloat_instances, "m", _FormFloat_shouldEnableFloat).call(this, element);
            });
        });
    }
}
_FormFloat_instances = new WeakSet(), _FormFloat_shouldEnableFloat = function _FormFloat_shouldEnableFloat(element) {
    if ($(element).val()) {
        $(element).addClass('focus');
    }
    else {
        $(element).removeClass('focus');
    }
};
